import React, { Component } from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { isNil, defaultTo, find, propEq, head, sum } from 'ramda';

import { routes } from '../../../../routes';
import { debounce } from '../../../../util/helpers';

import { apiGetExperiences, apiGetExperiencesFromRegistration } from '../../../../api/experience';
import Card from '../../../../components/Card';
import ExperiencesList from '../../../../components/ExperiencesList';

class List extends Component {
  static propTypes = {
    registrations: PropTypes.array,
    history: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const currentRegistration = defaultTo({}, head(props.registrations));

    this.state = {
      experiences: [],
      currentRegistration,
      loading: true,
    };

    this.onChangeRegistration(currentRegistration.id);
  }

  onChangeRegistration(id) {
    const { registrations } = this.props;
    apiGetExperiencesFromRegistration({ registrationId: id }).then(({ data }) =>
      this.setState({ experiences: data, currentRegistration: defaultTo({}, find(propEq('id', id), registrations)) }),
    );
  }

  render() {
    const { registrations } = this.props;
    const { currentRegistration, experiences } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col">
            <Card className="mb-4">
              <Card.Header compact>Experience Hours</Card.Header>
              <Card.Body>
                Choose a registration to view experience hours for it:
                <select
                  className="form-control form-control-sm w-auto d-inline-block ml-2"
                  onChange={(event) => this.onChangeRegistration(Number(event.target.value))}
                  value={currentRegistration.id}
                >
                  {registrations.map((registration) => (
                    <option key={registration.id} value={registration.id}>
                      {registration.certification.name}
                    </option>
                  ))}
                </select>
                <Link className="btn btn-primary float-right" to={routes.certificationsAndTraining.experience.add}>
                  Add
                </Link>
              </Card.Body>
            </Card>
            <Card>
              <Card.Header compact>
                Total Approved Hours: {sum(experiences.map((e) => (e.approved ? e.hours : 0)))} / Required Hours:{' '}
                {currentRegistration.requiredHours}
              </Card.Header>
              <Card.Body>
                <ExperiencesList registration={currentRegistration} experiences={experiences} />
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

export default List;
